import styled from 'styled-components'
import { UnstyledList } from '@velasca/ui/unstyled-list'
import { ViewElement } from '../CartDrawer.styles'

export const Listing = styled(ViewElement)`
  display: block;
  padding-bottom: 1.8rem;

  @media (min-width: 1349px) {
    display: none;
  }
`

export const RelatedProductsList = styled(UnstyledList)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
